




import Vue from 'vue';
import MaterialDbAdd from '@/components/material-db/material-db-add.component.vue';

export default Vue.extend({
  components: {
    'material-db-add': MaterialDbAdd,
  },
});
